module.exports = __webpack_public_path__ + "img/sumdes_460.839af1b1.png";